/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Rawwarning1Inputs */

const id_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snapshot ini belum diverifikasi; file mentahnya mungkin tidak lengkap.`)
};

const ms_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syot kilat ini belum disahkan; fail mentahnya mungkin tidak lengkap.`)
};

const da_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette snapshot er ikke bekræftet; råfilerne kan være ufuldstændige.`)
};

const de_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Snapshot wurde nicht verifiziert; seine Rohdateien können unvollständig sein.`)
};

const en_us2_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This snapshot has not been verified; its raw files may be incomplete.`)
};

const es_es2_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta compilación no está verificada; sus archivos sin procesar pueden estar incompletos.`)
};

const es_mx2_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta instantánea no está verificada; sus archivos sin procesar pueden estar incompletos.`)
};

const fil_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pa na-verify ang snapshot na ito; maaaring hindi kumpleto ang mga raw file nito.`)
};

const fr_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet instantané n’a pas été vérifié ; ses fichiers bruts peuvent être incomplets.`)
};

const it_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo snapshot non è stato verificato; i suoi file grezzi potrebbero essere incompleti.`)
};

const hu_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a pillanatkép nincs ellenőrizve; a nyers fájlok hiányosak lehetnek.`)
};

const nl_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze snapshot is niet geverifieerd; de raw bestanden kunnen onvolledig zijn.`)
};

const no_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette øyeblikksbildet er ikke bekreftet; råfilene kan være ufullstendige.`)
};

const pl_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten zrzut nie został zweryfikowany; jego surowe pliki mogą być niekompletne.`)
};

const pt_br2_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este snapshot não foi verificado; seus arquivos brutos podem estar incompletos.`)
};

const pt_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta captura não foi verificada; os seus ficheiros brutos podem estar incompletos.`)
};

const ro_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acest instantaneu nu a fost verificat; fișierele sale brute pot fi incomplete.`)
};

const fi_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tätä vedosta ei ole vahvistettu; sen raakatiedostot voivat olla puutteellisia.`)
};

const sv_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den här ögonblicksbilden har inte verifierats; råfilerna kan vara ofullständiga.`)
};

const vi_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh chụp này chưa được xác minh; các tệp thô có thể chưa đầy đủ.`)
};

const tr_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu anlık görüntü doğrulanmadı; ham dosyaları eksik olabilir.`)
};

const cs_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento snímek nebyl ověřen; jeho surové soubory mohou být neúplné.`)
};

const bg_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тази моментна снимка не е проверена; необработените ѝ файлове може да са непълни.`)
};

const ru_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот снимок не проверен; его исходные файлы могут быть неполными.`)
};

const uk_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей знімок не перевірено; його необроблені файли можуть бути неповними.`)
};

const ar_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم التحقق من هذه اللقطة؛ قد تكون ملفاتها الخام غير مكتملة.`)
};

const hi_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस स्नैपशॉट का सत्यापन नहीं हुआ है; इसकी कच्ची फ़ाइलें अधूरी हो सकती हैं।`)
};

const th_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สแนปช็อตนี้ยังไม่ได้รับการยืนยัน ไฟล์ดิบอาจไม่สมบูรณ์`)
};

const ja_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このスナップショットは検証されていません。未加工ファイルは不完全な場合があります。`)
};

const zh_cn2_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此快照尚未验证；其原始文件可能不完整。`)
};

const zh_hant1_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此快照尚未驗證；其原始檔案可能不完整。`)
};

const ko_builds_comparison_rawwarning1 = /** @type {(inputs: Builds_Comparison_Rawwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 스냅샷은 검증되지 않았습니다. 원시 파일이 불완전할 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "This snapshot has not been verified; its raw files may be incomplete." |
*
* @param {Builds_Comparison_Rawwarning1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_rawwarning1 = /** @type {((inputs?: Builds_Comparison_Rawwarning1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Rawwarning1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_rawwarning1(inputs)
	if (locale === "ms") return ms_builds_comparison_rawwarning1(inputs)
	if (locale === "da") return da_builds_comparison_rawwarning1(inputs)
	if (locale === "de") return de_builds_comparison_rawwarning1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_rawwarning1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_rawwarning1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_rawwarning1(inputs)
	if (locale === "fil") return fil_builds_comparison_rawwarning1(inputs)
	if (locale === "fr") return fr_builds_comparison_rawwarning1(inputs)
	if (locale === "it") return it_builds_comparison_rawwarning1(inputs)
	if (locale === "hu") return hu_builds_comparison_rawwarning1(inputs)
	if (locale === "nl") return nl_builds_comparison_rawwarning1(inputs)
	if (locale === "no") return no_builds_comparison_rawwarning1(inputs)
	if (locale === "pl") return pl_builds_comparison_rawwarning1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_rawwarning1(inputs)
	if (locale === "pt") return pt_builds_comparison_rawwarning1(inputs)
	if (locale === "ro") return ro_builds_comparison_rawwarning1(inputs)
	if (locale === "fi") return fi_builds_comparison_rawwarning1(inputs)
	if (locale === "sv") return sv_builds_comparison_rawwarning1(inputs)
	if (locale === "vi") return vi_builds_comparison_rawwarning1(inputs)
	if (locale === "tr") return tr_builds_comparison_rawwarning1(inputs)
	if (locale === "cs") return cs_builds_comparison_rawwarning1(inputs)
	if (locale === "bg") return bg_builds_comparison_rawwarning1(inputs)
	if (locale === "ru") return ru_builds_comparison_rawwarning1(inputs)
	if (locale === "uk") return uk_builds_comparison_rawwarning1(inputs)
	if (locale === "ar") return ar_builds_comparison_rawwarning1(inputs)
	if (locale === "hi") return hi_builds_comparison_rawwarning1(inputs)
	if (locale === "th") return th_builds_comparison_rawwarning1(inputs)
	if (locale === "ja") return ja_builds_comparison_rawwarning1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_rawwarning1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_rawwarning1(inputs)
	return ko_builds_comparison_rawwarning1(inputs)
});
export { builds_comparison_rawwarning1 as "builds.comparison.rawWarning" }